<button type="button" class="bell-btn" [matMenuTriggerFor]="bellMenu" (menuOpened)="refresh()"
        matTooltip="Notifications" aria-label="Notifications">
    <mat-icon>notifications</mat-icon>
    <span *ngIf="unreadCount > 0" class="bell-badge">{{ badgeText() }}</span>
</button>

<mat-menu #bellMenu="matMenu" xPosition="before" class="bell-menu-panel">
    <div class="bell-head" (click)="$event.stopPropagation()">
        <span class="bell-title">Notifications</span>
        <button *ngIf="unreadCount > 0" type="button" class="bell-mark-all" (click)="markAllRead($event)">
            Mark all read
        </button>
    </div>

    <div *ngIf="items.length === 0" class="bell-empty" (click)="$event.stopPropagation()">
        Nothing yet - payroll request activity shows up here.
    </div>

    <button *ngFor="let n of items" mat-menu-item class="bell-item" [class.unread]="!n.readOn" (click)="open(n)">
        <!-- Material wraps a menu item's content in its own .mat-mdc-menu-item-text span, so the
             layout lives on THIS wrapper (in the component template, reachable by encapsulated
             styles): a title row with the time right-aligned, the body underneath. -->
        <div class="bell-item-inner">
            <div class="bell-item-row">
                <span class="bell-item-dot" aria-hidden="true"></span>
                <span class="bell-item-title">{{ n.title }}</span>
                <span class="bell-item-when">{{ n.createdOn | date:'MM/dd h:mm a' }}</span>
            </div>
            <span *ngIf="n.body" class="bell-item-body">{{ n.body }}</span>
        </div>
    </button>
</mat-menu>
